module.exports = __webpack_public_path__ + "img/00020.e4069d5e.webp";